import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	name: {
		id: 'custom-content.custom-content-space-list-view.name',
		defaultMessage: 'Name',
		description: 'The title for custom content title column',
	},
	contributors: {
		id: 'custom-content.custom-content-space-list-view.contributors',
		defaultMessage: 'Contributors',
		description: 'The title for custom content contributors column',
	},
	lastModified: {
		id: 'custom-content.custom-content-space-list-view.lastModified',
		defaultMessage: 'Last Modified',
		description: 'The title for last modified column',
	},
	noCustomContent: {
		id: 'custom-content.custom-content-space-list-view.noResults',
		// TODO: replace straight quotes with curly quotes (see go/curlyquotes)
		// eslint-disable-next-line no-restricted-syntax
		defaultMessage: "There's nothing here but potential",
		description: 'Message saying that no custom content items',
	},
	timeToFill: {
		id: 'custom-content.custom-content-space-list-view.timeToFill',
		defaultMessage: 'Time to fill this space with something awesome.',
		description: 'Message saying that no results found and time to add a new custom content',
	},
	noItems: {
		id: 'custom-content.custom-content-space-list-view.noItems',
		defaultMessage: 'No items',
		description: 'Message saying that there is no items in the list',
	},
	errorTitle: {
		id: 'custom-content.custom-content-space-list-view.errorTitle',
		defaultMessage: 'Something went wrong.',
		description: 'Title for section that appears when an error occurs during API call',
	},
	errorBody: {
		id: 'custom-content.custom-content-space-list-view.errorBody',
		defaultMessage: 'Please try again later.',
		description: 'Body for section that appears when an error occurs during API call',
	},
});
